import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../../../theme/tokens';

export const MapFrame = styled(Box)(() => ({
  height: '620px',
  borderRadius: '16px',
  overflow: 'hidden',
  border: `1px solid ${protoColors.border}`,
  '& .rede-proto-map': {
    width: '100%',
    height: '100%',
  },
}));

export const Placeholder = styled(Box)(() => ({
  height: '620px',
  borderRadius: '16px',
  border: `1px dashed ${protoColors.border}`,
  backgroundColor: protoColors.surfaceSubtle,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  textAlign: 'center',
  padding: '24px',
  color: protoColors.textMuted,
}));

export const Dot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'selected',
})<{ color: string; selected: boolean }>(({ color, selected }) => ({
  display: 'block',
  width: selected ? '20px' : '14px',
  height: selected ? '20px' : '14px',
  borderRadius: '50%',
  backgroundColor: color,
  border: `2px solid ${selected ? protoColors.ink : '#FFFFFF'}`,
  boxShadow: '0 1px 4px rgba(0,0,0,0.35)',
  cursor: 'pointer',
  transition: 'all 0.1s ease',
}));
